import { FETCHING_COMPANY_SUCCESS } from '../../../../actions/companyDetail';

export default function(state = 0, action) {
  if (action.type === FETCHING_COMPANY_SUCCESS) {
    return action.response.data.buyerProjects.reduce((result, project) => {
      if (result) return result;
      if (project.type && project.type.toLowerCase() === 'add-on') {
        return project.id;
      }

      return result;
    }, 0);
  }

  return state;
}
